<template>
  <Page>
    <template v-slot:page-header>
      <div class="container">
        <div class="page-header">
          <div class="title-container">
            <div class="title">ตกแต่ง{{pageTitle}}</div>
          </div>
        </div>
      </div>
    </template>
    <div class="container">
      <div class="section-container" v-if="designComponents && designComponents.length > 0">
      <!-- <Popup
        class="popup-section section"
        :items="popupItem.data.items"
        :name="popupItem.name"
        :popupId="popupItem.id"
        v-if="popupItem" /> -->
        <div
          v-for="(component, componentIndex) in designComponents"
          :key="componentIndex">
          <!-- slider component v-if="type === 'slider'"-->
          <Slider
            class="slider section"
            :items="component.data.items"
            :name="component.name"
            :sliderId="component.id"
            v-if="component.type === 'slider'"/>
          <Banner
            class="banner section"
            :items="component.data.items"
            :bannerId="component.id"
            :name="component.name"
            v-if="component.type === 'banner'"/>
          <div class="mockup-component" v-if="component.type === 'placeholder'">
            <div class="mockup-section section">
              <div class="mockup-title">{{component.name}}</div>
              <div class="box-wrapper">
                <div class="mockup-box" v-for="(i, index) in 3" :key="index" />
              </div>
            </div>
          </div>
          <Grid
            class="grid section"
            :items="component.data.items"
            :id="component.id"
            :name="component.name"
            v-if="component.type === 'grid'" />
        </div>
      </div>
    </div>
  </Page>
</template>

<script>
// import _ from 'lodash';
import Page from '@/layouts/Page.vue';

import { loadPageDesignerByKey } from './api';
import Slider from './slider/Slider.vue';
import Banner from './banner/Banner.vue';
import Grid from './grid/Grid.vue';
// import Popup from './popup/Popup.vue';

export default {
  components: {
    Page,
    Slider,
    Banner,
    Grid,
    // Popup,
  },
  computed: {
    pageDesignerKey() {
      return this.$route.params.pageDesignerKey;
    },
    // popupItem() {
    //   return _.find(this.designComponents, (component) => component.type === 'popup');
    // },
  },
  watch: {
    $route() {
      this.load();
    },
  },
  data() {
    return {
      pageTitle: '',
      designComponents: [],
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      const reponse = await loadPageDesignerByKey(this.pageDesignerKey);
      this.pageTitle = reponse.data.title;
      this.designComponents = reponse.data.components;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/layouts/page.scss';
@import './src/assets/scss/themes/components/section-container.scss';

.section-container {
  .section {
    box-shadow:  0 0 30px 0 rgba(82, 63, 105, 0.05);
    margin-bottom: $spacer * 1.5;
  }
  .mockup-component {
    .mockup-section {
      background: white;
      height: 300px;
      padding: $spacer / 2 $spacer;
      .mockup-title {
        font-size: $font-size-base * 1.75;
        font-family: $font-family-DBHeavent !important;
      }
      .box-wrapper {
        display: flex;
        align-items: center;
        margin-top: $spacer;
        .mockup-box {
          flex: 1;
          margin-right: $spacer;
          height: 200px;
          background: $gray-200;
        }
        .mockup-box:last-child {
          margin: 0;
        }
      }
    }
  }
}

.popup-section {
  box-shadow: 0 0 0 0 !important;
}


@media (max-width: 575.98px) {
  .section-container {
    .mockup-component {
      .mockup-section {
        height: 175px;
        .box-wrapper {
          margin-top: $spacer / 2;
          .mockup-box {
            flex: 1;
            margin-right: $spacer / 2;
            height: 100px;
          }
        }
      }
    }
  }
}
</style>
